import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NavigationComponentManagerComponent} from './navigation-component-manager.component';
import {ConfigModule} from '@spartacus/core';
import {QuickLinksModule} from '../../homepage/quick-links/quick-links.module';
import {HelpIconModule} from '../../layout/header/help-icon/help-icon.module';
import {UserMenuModule} from '../../layout/header/user-menu/user-menu.module';
import {DropdownModule} from '../../directives/dropdown/dropdown.module';


@NgModule({
  declarations: [NavigationComponentManagerComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NavigationComponent: {
          component: NavigationComponentManagerComponent
        }
      }
    }),
    QuickLinksModule,
    HelpIconModule,
    UserMenuModule,
    DropdownModule
  ],
  exports: [
    NavigationComponentManagerComponent
  ]
})
export class NavigationComponentManagerModule {
}
